export const enum POST_TYPE {
  Community = 'community',
  Blog = 'blog',
}